import { typographyToCss } from 'shared/lib/mui';
import styled, { css } from 'styled-components';

export const ChartWrapper = styled.div<{ $fillHeight?: boolean }>`
  width: 100%;

  ${({ $fillHeight }) =>
    $fillHeight &&
    css`
      height: 100%;
    `};
`;

export const ProgressGradient = styled.linearGradient<{
  $isComplete?: boolean;
}>`
  stop:first-child {
    stop-color: ${({ theme, $isComplete }) =>
      $isComplete
        ? theme.palette.success.main
        : theme.palette.primaryExtended.opacityBackgroundText};
    stop-opacity: 0.2;
  }

  stop:last-child {
    stop-color: ${({ theme, $isComplete }) =>
      $isComplete
        ? theme.palette.success.main
        : theme.palette.primaryExtended.opacityBackgroundText};
    stop-opacity: 0;
  }
`;
export const EstimateGradient = styled.linearGradient`
  stop:first-child {
    stop-color: ${({ theme }) => theme.palette.divider};
    stop-opacity: 0.3;
  }

  stop:last-child {
    stop-color: ${({ theme }) => theme.palette.divider};
    stop-opacity: 0;
  }
`;

export const SvgCircle = styled.circle<{
  $content?: string;
  $isComplete?: boolean;
}>`
  stroke: ${({ theme, $isComplete }) =>
    $isComplete
      ? theme.palette.success.main
      : theme.palette.primaryExtended.opacityBackgroundText};
  stroke-width: ${({ theme }) => theme.spacing(0.5)};
  fill: ${({ theme }) => theme.palette.background.default};
  r: ${({ theme }) => theme.spacing(1.5)};
`;

export const SvgDotText = styled.text`
  ${({ theme }) => typographyToCss(theme.typography.h6)};

  fill: ${({ theme }) => theme.palette.text.primary};
`;
